import { render, staticRenderFns } from "./ChildrenPane.vue?vue&type=template&id=4f9b7389&scoped=true&"
import script from "./ChildrenPane.vue?vue&type=script&lang=js&"
export * from "./ChildrenPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b7389",
  null
  
)

export default component.exports